import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
const DESKTOP = '@media (min-width: 60rem)';

// Mobile = single column, identity centered (mirrors the Flutter About tab).
// Desktop (>=60rem) = sticky identity column (left) + about content (right).
export const styles = {
  container: {
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    maxWidth: "x6ymgno x1azjtmf",
    paddingTop: "x128v7jw",
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBottom: "x1q8uoa4",
    display: "x1lliihq x2399xu",
    gridTemplateColumns: "x1noms9b x184urxs",
    columnGap: "x1o1pmfc x9ke802",
    alignItems: "x1qjc9v5 x1x5jrqe",
    $$css: true
  },
  identity: {
    gridColumn: "xm5moh1 x1qjfwf0",
    gridColumnStart: null,
    gridColumnEnd: null,
    position: "x1uhb9sk x1bn53jn",
    top: "xm3se36",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    textAlign: "x2b8uid",
    marginBottom: "xhbfen4 x19utzmi",
    $$css: true
  },
  nameRow: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    marginTop: "x1c4vshn",
    $$css: true
  },
  verified: {
    color: "x1bj2zf7",
    flexShrink: "x2lah0s",
    $$css: true
  },
  name: {
    fontSize: "x1q74xe4",
    lineHeight: "x1u7k74",
    fontWeight: "xlr2uoh",
    color: "xtt1gjl",
    $$css: true
  },
  username: {
    marginTop: "x1tbvfm1",
    fontSize: "x1lkfr7t",
    fontWeight: "xr323w7",
    color: "xarw3lm",
    $$css: true
  },
  cta: {
    width: "xh8yej3",
    marginTop: "x1c4vshn",
    $$css: true
  },
  content: {
    gridColumn: "xm5moh1 x1tiv5ds",
    gridColumnStart: null,
    gridColumnEnd: null,
    marginTop: "x1c4vshn x1dhnvac",
    $$css: true
  },
  bio: {
    display: "x78zum5",
    alignItems: "x1cy8zhl",
    gap: "xb6y1gh",
    rowGap: null,
    columnGap: null,
    backgroundColor: "x80m72e",
    borderRadius: "xdkhd45",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x1uz70x1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    marginBottom: "x1nhhxel",
    $$css: true
  },
  bioIcon: {
    color: "x1gonuu0",
    flexShrink: "x2lah0s",
    marginTop: "x72edsj",
    $$css: true
  },
  bioText: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x6u19be",
    lineHeight: "x1evy7pa",
    color: "xtt1gjl",
    $$css: true
  }
};